export const modals = {
  copy: 'Copy configuration template',
  copySuccess: 'Configuration template copied successfully',
  delete: 'Delete configuration template',
  deleteConfirm: 'Are you sure you want to delete the configuration template?',
  deleteSuccess: 'Configuration deleted',
} as const
